export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fd211b9988fe6c8e8019eb32cbd11107f83b7b97b&name=fetchTypeahead!'